module.exports = __webpack_public_path__ + "static/amoebaIcon-e12475b78d2a687c3d03b9c835ee6aef.png";